import React from 'react';
import { INSTANCE_HOME, isNavItemActive } from './adminNav';
import { StageSelector, StageButton } from './InstanceNav.styles';

/**
 * The stage selector: ⌂ Yleiskuva, then Valmistelu / Toteutus / Tulokset /
 * Seuranta as the user may open them. On a wide screen it sits in the top bar
 * next to the instance chip; below TOP_STAGES_MIN it is the start of the
 * stage row (AdminHeader.styles.js WideOnly / NarrowOnly). The stage the
 * instance is in has a dot; choosing a stage opens its first page.
 */
const StageSwitcher = ({ stages, showHome, pathname, activeStage, instanceStage, buildPath, navTo }) => {
  const HomeIcon = INSTANCE_HOME.icon;
  return (
    <StageSelector role="tablist" aria-label="Työpajan vaiheet">
      {showHome && (
        <StageButton
          type="button"
          role="tab"
          aria-selected={isNavItemActive(INSTANCE_HOME, pathname)}
          aria-label={INSTANCE_HOME.label}
          title={INSTANCE_HOME.label}
          $active={isNavItemActive(INSTANCE_HOME, pathname)}
          onClick={() => navTo(buildPath(INSTANCE_HOME.path))}
        >
          <HomeIcon size={14} />
        </StageButton>
      )}
      {stages.map((stage) => {
        const Icon = stage.icon;
        const active = activeStage?.key === stage.key;
        return (
          <StageButton
            key={stage.key}
            type="button"
            role="tab"
            aria-selected={active}
            title={stage.label}
            $active={active}
            $current={instanceStage === stage.key}
            onClick={() => navTo(buildPath(stage.items[0].path))}
          >
            <Icon size={14} />
            <span>{stage.label}</span>
          </StageButton>
        );
      })}
    </StageSelector>
  );
};

export default StageSwitcher;
